export default __webpack_public_path__ + "static/media/LogoColored.4b67ca46.png";